export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s tidak dipilih';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s tidak boleh dibiarkan kosong';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s adalah ruang wajib';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s tidak diisi dengan betul';
                break;

            case 'opt-in':
                translation = 'Sila tandakan kotak untuk meneruskan';
                break;

            default:
                translation = 'Ruang ini tidak diisi dengan betul';
                break;
        }

        return translation;
    }
}
